/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from "@material-ui/core/styles/";
import { debounce } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { RiSearchLine } from "react-icons/ri";
import Swal from "sweetalert2";
import HeaderButton from "../../../../pages/admin/components/headerButton";
import { MutantApiService } from "../../../../services/MutantApiService";
// import RefreshButton from "../../pages/admin/components/RefreshButton";
import {
	Paper, Table,
	TableBody, TableCell, TableFooter, TableHead,
	TablePagination,
	TableRow,
	TableSortLabel
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { AdminTitle } from "../../../../pages/admin/components/AdminTitle";
import EditorConvertToHTML from "../../../../pages/admin/components/EditorConvertToHTML";
import Loading from "../../../../pages/home/components/Loading";
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { StyledTableCell, StyledTableRow } from "./styles";
import { Col, Form, Spinner } from "react-bootstrap";
import { InputField } from "../../../../components/Input";
import { getStatusTranslation } from "./PromptsListing";
import "./Datatable.scss";

const EnhancedTableHead = props => {
	const { order, orderBy, onRequestSort, headRows } = props;

	const createSortHandler = property => event => {
		if (!property) {
			return;
		}

		onRequestSort(event, property);
	};

	const generateRow = headRows => (
		<TableRow>
			{(headRows || []).map((row, i) => (
				<TableCell
					style={{ paddingLeft: 7 }}
					key={row.column || i}
					align={row.align ? row.align : "start"}
					padding={row.disablePadding ? "none" : "default"}
					sortDirection={orderBy === row.column ? order : false}
					size={row.size || null}
					width={row.width || undefined}
					variant="head"
					component={
						props.styledTableCell !== undefined
							? props.styledTableCell
							: StyledTableCell
					}
				>
					{row.column ? (
						<TableSortLabel
							active={orderBy === row.column}
							direction={order}
							onClick={createSortHandler(row.column)}
						>
							{row.label}
						</TableSortLabel>
					) : (
						row.label
					)}
				</TableCell>
			))}
		</TableRow>
	);

	return (
		<TableHead>
			{Array.isArray(headRows[0]) &&
				headRows.map(row => {
					return generateRow(row);
				})}
			{!Array.isArray(headRows[0]) && generateRow(headRows)}
		</TableHead>
	);
};

EnhancedTableHead.propTypes = {
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.string.isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
	headRows: PropTypes.array.isRequired
};

const api = new MutantApiService();

function Datatable(props) {
	console.log("\n\n\n Datatable ~ props: ", props)
	const { widthTable } = props;
	const useStyles = makeStyles(() => {
		return {
			root: {
				display: "flex",
				flexDirection: "column",
				width: "100%",
				height: "100%"
			},
			paper: {
				width: "100%",
				flex: "1",
				padding: "20px",
				marginTop: "10px",
			},
			table: {
				minWidth: widthTable ? widthTable : 400,
				overflowX: "scroll",
			},
			tableWrapper: {
				display: "flex",
				justifyContent: "space-between",
				flexDirection: "column",
				height: "100%",
				borderBottomLeftRadius: "4px",
				borderBottomRightRadius: "4px",
				overflowX: props.overflowX ?? "auto",
			},
			search: {
				backgroundColor: "#ffffff",
				display: "flex",
				flexWrap: "wrap"
			},
			addBtn: {
				padding: "24px 0",
				marginLeft: "16px"
			},
			selectFilters: {
				display: "flex",
				maxWidth: "300px",
				width: "16%",
				padding: "24px 0",
				marginLeft: "16px"
			},
			tableLight: {
				backgroundColor: "#ffffff !important",
				'& tbody tr': {
					borderBottom: '1px solid #cccccc !important',
				}
			},
		};
	});

	const classes = useStyles();
	const currentState = loadPaginationState();

	const rows = props.rows || [];
	const [order, setOrder] = React.useState(currentState.orderByDirection || "desc");
	const [orderBy, setOrderBy] = React.useState(
		currentState.orderBy || props.orderBy || props.headRows[0].column || "id"
	);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(
		props.rowsPerPage || currentState.perPage || 10
	);
	const [count, setCount] = React.useState(rows.length);
	const [isLoading, setIsLoading] = React.useState(false);
	const [isLoadingExport, setIsLoadingExport] = React.useState("");
	const [status, setStatus] = React.useState("");
	const [reload, setReload] = React.useState(props.reload || false);
	const pageCurrentState = currentState.page;

	const onSearch = useRef(
		debounce((e, searchLoad) => {
			if (e.length >= 3 || e.length === 0) {
				searchLoad(e);
			}
		}, 500)
	).current;

	function search(e, select) {
		props.setInputSearch(e.target.value);
		onSearch(e.target.value, e => searchLoad(e));
	}

	function searchLoad(e) {
		loadRecords({
			page: 1,
			perPage: rowsPerPage,
			status: status.value,
			search: e
		});
	}

	useEffect(() => {
		if (props.search) {
			search({ target: { value: props.search } });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	async function loadRecords(config = {}) {
		setIsLoading(true);
		console.log("\n\n\n Datatable loadRecords ~ config: ", config)

		let params = {
			page: (config.page),
			perPage: config.perPage || rowsPerPage,
			orderBy: config.orderBy || orderBy,
			orderByDirection: config.orderByDirection || order,
			filterString: config.search,
			filterType: config.filterType,
			ritualType: props.ritualType ?? null,
			startPeriod: props.dateRange ? props.dateRange.startPeriod : null,
			endPeriod: props.dateRange ? props.dateRange.endPeriod : null,
			hasPeriod: Boolean(props.dateRange),
			status: config.status,
			...config.filters
		};
		params.page = params.page+1;
		try {
			console.log("\n\n\n Datatable loadRecords ~ params: ", params)
			const response = await api.makeHttpRequest({
				url: `${props.endpoint}?page=${params.page}&perPage=${params.perPage}${params.filterString ? '&search=' + params.filterString : ''}${params.status ? '&status=' + params.status : ''}`,
				method: 'GET'
			})
			console.log("\n\n\n Datatable loadRecords ~ response: ", response)


			if (props.setCountAndFilter) {
				props.setCountAndFilter(response.count, {
					...params,
					page: response.meta.currentPage,
					perPage: response.meta.perPage,
					status: config.status ? config.status : []
				});
			}

			if (props.notPaginated) {
				setCount(response.meta.total || 0);
				props.setRows(response.data || []);
			} else {
				setCount(response.meta.total);
				props.setRows(response.data || []);
				console.log("\n\nset page : ", response.meta)

				setPage(params.page - 1);
			}

			savePaginationState(params);

		} catch (e) {
			Swal.fire(
				"Erro!",
				e?.response?.data ? e.response.data : "Erro ao carregar os dados, tente novamente mais tarde.",
				"error"
			);
		} finally {
			setIsLoading(false);
			setReload(false);
		}
	}

	useEffect(() => {
		if (props.idProject && props.reloadEvery) {
			const intervalId = setInterval(async () => {
				if (!props.inputSearch && !status) {
					try {
						const response = await api.makeHttpRequest({
							url: `projects/${props.idProject}/prompts?page=${page}&perPage=${rowsPerPage}`
						});

						setCount(response.meta.total);
						props.setRows(response.data);
					} catch (e) {}
				}
			}, props.reloadEvery)

			return () => {
				clearInterval(intervalId);
			};
		}
	}, [props.inputSearch, status]);

	useEffect(() => {
		if (!props.cancelReload) {
			loadRecords({
				page: props.skipPaginationState === false ? pageCurrentState || page : page,
				search: props.inputSearch
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.reload]);

	useEffect(() => {
		loadRecords({
			page: page,
			search: props.inputSearch,
			status: status.value
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [status]);

	function loadPaginationState() {
		const paginationState = JSON.parse(
			localStorage.getItem("pagination") || "{}"
		);
		if (paginationState[props.endpoint]) {
			return paginationState[props.endpoint];
		}

		return {};
	}

	function savePaginationState(state) {
		const paginationState = JSON.parse(
			localStorage.getItem("pagination") || "{}"
		);

		paginationState[props.endpoint] = state;

		localStorage.setItem("pagination", JSON.stringify(paginationState));
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		const direction = isDesc ? "asc" : "desc";
		setOrder(direction);
		setOrderBy(property);
		loadRecords({
			orderByDirection: direction,
			orderBy: property === "Perfil" ? "Perfil.Nome" : property,
			search: props.inputSearch,
			filterType: props.filterType,
			filters: props.filters || {}
		});
	}

	function handleChangePage(_, newPage) {
		setPage(newPage);
		loadRecords({
			page: newPage,
			search: props.inputSearch,
			filterType: props.filterType,
			filters: props.filters || {}
		});
	}

	function handleChangeRowsPerPage(event) {
		setPage(0);
		setRowsPerPage(+event.target.value);
		loadRecords({
			perPage: event.target.value,
			page: 1,
			search: props.inputSearch,
			filterType: props.filterType,
			filters: props.filters || {}
		});
	}

	function refreshAction() {
		loadRecords({
			page: pageCurrentState || page,
			search: props.inputSearch
		});
	}

	if (reload) {
		refreshAction();
	}

	const generateMobileButtons = () => {
		return (
			<>
				{!props.hiddenReload && (
					<li className="kt-nav__item">
						<a href={void 0} className="kt-nav__link" onClick={refreshAction}>
							<i className="kt-nav__link-icon flaticon2-reload"></i>
							<span className="kt-nav__link-text">Atualizar</span>
						</a>
					</li>
				)}

				{props.buttons.length > 0
					? props.buttons.map((btn, i) => {
						const btnOnClick = btn.endpoint
							? () => {}
							: btn.onClick;

						return btn.path ? (
							<Link to={btn.path} className="kt-nav__item" key={i}>
								<span className="kt-nav__link" onClick={btnOnClick}>
									<i
										className={`kt-nav__link-icon flaticon-${btn.icone}`}
									></i>
									<span className="kt-nav__link-text">
										{btn.label}
									</span>
								</span>
							</Link>
						) : (
							<li className="kt-nav__item" key={i}>
								<a
									href={btn.link}
									className="kt-nav__link"
									onClick={() => console.log('teste...')}
								>
									<i
										className={`kt-nav__link-icon flaticon-${btn.icone}`}
									></i>
									<span className="kt-nav__link-text">
										{btn.label}
									</span>
								</a>
							</li>
						);
					})
					: null}
			</>
		);
	};

	let statusOptions = ['ENQUEUED', 'PROCESSING', 'PROCESSED', 'FAILED']

	return (
		<div
			className={`col - xl - 12 ${props.className}`}
			style={{ marginTop: "10px", minHeight: "max-content" }}
		>
			<Loading isLoading={isLoading || isLoadingExport} />
			<Portlet fluidHeight={true} style={{ backgroundColor: "transparent" }}>
				{props.title && props.icon ? (
					<AdminTitle
						icon={props.icon}
						title={props.title}
						disableHeader={props.disableHeader}
						width={props.width}
						mobile={props.mobile}
						actions={props.actions}
						refreshAction={props.refreshAction}
						generateMobileButtons={generateMobileButtons}
					/>
				) : null}

				<PortletBody fit={true} fluid={true}>
					<div className={classes.root}>
						{props.formView ? props.formView : null}

						{props.placeholderSearch ? (
							<div className={classes.search}>
								<div
									className="kt-input-icon kt-input-icon--left"
									style={{ flex: 1, minWidth: "235px", padding: "24px 0" }}
								>
									<div style={{ display: "flex", flexDirection: 'row', gap: '16px' }}>
										<span
											className="kt-input-icon__icon kt-input-icon__icon--left"
											style={{
												position: "absolute",
												margin: "12px 17px"
											}}
										>
											<RiSearchLine size="24px" color="#4D4C4D" />
										</span>
										<input
											style={{
												height: "48px",
												borderColor: "#4D4C4D",
												fontFamily: "'Cera Pro Light', sans-serif",
												paddingLeft: "56px"
											}}
											type="text"
											className="form-control"
											placeholder={props.placeholderSearch}
											onChange={search}
											value={props.inputSearch}
										/>

										<InputField
											as="select2"
											name="status"
											value={status}
											onChange={(e) => {
												setStatus(e ?? '')
											}}
											placeholder="Filtre por status"
											closeMenuOnSelect={false}
											isClearable={true}
											options={statusOptions.map(item => {
												return {
													label: getStatusTranslation(item),
													value: item
												}
											})}
										/>
									</div>


								</div>

								{props.width >= 768 || !props.mobile ? (
									<>
										{props.buttons && props.buttons.length > 0 ? (
											<>
												{props.buttons.map((item, index) => (
													<div className={classes.addBtn} key={index}>
														<HeaderButton
															loading={item.loading}
															path={item.path}
															label={item.label}
															link={item.link}
															onClick={
																item.endpoint
																	? () => {}
																	: item.onClick
															}
															icone={item.icone}
															RIcone={item.RIcone}
															disabled={item.disabled}
															style={{
																borderRadius: "6px",
															}}
														/>
													</div>
												))}

												{/* {!props.hiddenReload && (
                          <RefreshButton refreshAction={refreshAction} />
                        )} */}
											</>
										) : null}
									</>
								) : null}
							</div>
						) : null}

						{props.editorEmail ? (
							<EditorConvertToHTML
								resetEditor={props.resetEditor}
								getEmail={(html, assunto) => props.setEmail(html, assunto)}
							/>
						) : null}

						<Paper className={classes.paper}>
							<div className={classes.tableWrapper}>
							<Table id="datatable-table" className={`${classes.table} ${classes.tableLight}`}>
									<EnhancedTableHead
										order={order}
										orderBy={orderBy}
										onRequestSort={handleRequestSort}
										rowCount={rows.length}
										headRows={props.headRows}
										styledTableCell={props.styledTableCell}
									/>
									<TableBody style={{ height: "100%" }}>
										{isLoading ? (
											<TableRow
												component={
													props.styledTableRow !== undefined
														? props.styledTableRow
														: StyledTableRow
												}
											>
												<TableCell
													colSpan={props.headRows.length}
													className="text-center"
													component={
														props.styledTableCell !== undefined
															? props.styledTableCell
															: StyledTableCell
													}
												>
													Aguarde...
												</TableCell>
											</TableRow>
										) : count > 0 ? (
											rows.map((row, i) => props.formatRow(row, i))
										) : (
											<TableRow
												component={
													props.styledTableRow !== undefined
														? props.styledTableRow
														: StyledTableRow
												}
											>
												<TableCell
													colSpan={props.headRows.length}
													className="text-center"
													component={
														props.styledTableCell !== undefined
															? props.styledTableCell
															: StyledTableCell
													}
												>
													Nenhum registro encontrado.
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
								{!props.hiddenFooterPagination ? (
									<Table>
										<TableFooter>
											<TableRow>
												<TablePagination
													rowsPerPageOptions={[10, 20, 50]}
													colSpan={10}
													count={count || 0}
													rowsPerPage={rowsPerPage}
													page={page}
													labelRowsPerPage="Registros por página"
													backIconButtonProps={{
														"aria-label": "Anterior"
													}}
													nextIconButtonProps={{
														"aria-label": "Próxima"
													}}
													onChangePage={handleChangePage}
													onChangeRowsPerPage={handleChangeRowsPerPage}
												/>
											</TableRow>
										</TableFooter>
									</Table>
								) : null}
							</div>
						</Paper>
					</div>
				</PortletBody>
			</Portlet>
		</div>
	);
}

export default Datatable;
